import { Avatar, AvatarSize, FlexBox, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
type UserProfileRestrictedProps = {
  /** The size of the avatar. */
  avatarSize?: AvatarSize;
  /** The color of the text */
  color?: string;
};

export const UserProfileRestricted = ({
  avatarSize,
  color,
}: UserProfileRestrictedProps): JSX.Element => (
  <FlexBox gap="200" alignItems="center">
    <Avatar
      icon="user-secret"
      color={{
        backgroundColor: colors.neutral['200'],
        contentColor: colors.neutral['700'],
      }}
      size={avatarSize || '24'}
    />
    <Text.Paragraph color={color}>Restricted content</Text.Paragraph>
  </FlexBox>
);
